export const navigation = {
  main: [
    { name: 'About', href: '/about#top' },
    { name: 'Programs', href: '/programs/cafp#top' },
    /*{ name: 'Research', href: '/research#top' },*/
    { name: 'Events', href: '/events#top' },
    { name: 'Contact', href: '/contact#top' },
  ],
  social: [
    {
      name: 'X',
      href: 'https://x.com/CFSC_UG',
    },
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/mubs-sustainability-and-climate-finance-centre/',
    },
  ],
};